export default {"src":"/_next/static/media/temp-1-new.798765bc.svg","height":447,"width":565,"blurWidth":0,"blurHeight":0};